import { TranslateService } from '@ngx-translate/core';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls:['./confirmation-dialog.component.scss'],
  //`.mat-dialog-container{ border-radius:24px !important}`
 })
export class ConfirmationDialog {
  message: string = this.translate.instant("ARE_YOU_SURE") + '?';
  title: string = 'Подтверждать';
  width = 400;
  confirmButtonText = this.translate.instant("YES");
  cancelButtonText = this.translate.instant("CANCEL");
  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialog>,
    private translate: TranslateService) {
    if (data) {
      this.message = data.message || this.message;
      this.title = data.title || this.title;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
